import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Link,
} from "@mui/material";
import { loginUser } from "../../services/apiCalls";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useDispatch } from "react-redux";
import { clearCartThunk } from "../../features/cart/cartThunks";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { login } = useAuth();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await loginUser(email, password);
      if (response.http_status === 200) {
        const { token, info } = response.data;
        login(token, info); // Pass both token and user info to login
        setSuccess("Login successful!");
        dispatch(clearCartThunk());
        navigate("/profile");
      } else {
        setError(response.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "30vh",
        mt: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:"auth.main",
      }}
    >
      <Paper elevation={0} sx={{ p: 3 ,backgroundColor:"auth.main"}}>
      <Typography variant="h4" align="center" sx={{ mb: 1 ,fontFamily: "'Playfair Display', serif", 
    fontWeight: 600,
    fontSize: "50px",
    lineHeight: 1.2}}>
            Create Your Account
          </Typography>
          <Typography variant="body2" align="center"sx={{ mb: 2, color: "text.secondary" }}>
          Please enter your login credentials to access your account.
          </Typography>
        
        {error && (
          <Typography variant="body2" color="error" align="center">
            {error}
          </Typography>
        )}
        {success && (
          <Typography variant="body2" color="success" align="center">
            {success}
          </Typography>
        )}
        <Box component="form" onSubmit={handleSignIn}>
          <TextField
            fullWidth
            label="Email"
            // variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            margin="normal"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            type="submit"
          >
            Sign In
          </Button>
        </Box>
        <Box textAlign="center" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <Link href="/forgot-password" color="primary">
              Forgot your password?
            </Link>
          </Typography>
        </Box>
        <Box textAlign="center" sx={{ mt: 2 }}>
          <Typography variant="body2">
            Don't have an account?{" "}
            <Link href="/signup" color="primary">
              Sign Up
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default SignInPage;
